import React, { useEffect } from "react";
import { RxCross2 } from "react-icons/rx";
import { IoSettingsOutline } from "react-icons/io5";

const CommonInput = (props) => {

  const datemin = props?.type === "date" ? (props?.min ? props.min : '') : props?.min;

  const {
    type = "text",
    name,
    label,
    error,
    focus,
    labelClass,
    error_class = "",
    onChange,
    onBlur,
    value,
    placeholder = '',
    className = "",
    min = datemin,
    max = 1000,
    onInput = () => { },
    maxLength = 1000,
    disabled = false,
    ref = null,
    preAddon = false,
    postAddon = false,
    onKeyDown,
    onClick,
    onFocus,
    labelRedStar = false,
    accept,
    isClearOption = false,
    rupeeSymbol = false,
    isClearHandleChange,
    errorShow = true,
    minLength = 0,
    settingIcon = false,
    isSettingHnadle = () => { },
    preText = "",
    postText = "",
    postButton = false,
  postButtonLabel = "",
  onPostButtonClick = () => { },
  } = props;

  const invalid = !!(focus && error);
  const valid = !!Boolean(focus && !error);

  useEffect(() => {
    const inputFields = document.querySelectorAll("input");
    inputFields.forEach((input) => {
      input.setAttribute("autocomplete", "off");
    });
  }, []);

  return (
    <div className={error ? "anvCustom_floatInput form-floating anvInputError" : "anvCustom_floatInput form-floating "}>

      {preAddon && (
        <>
          <div className="__preNums">{preText}</div>
        </>
      )}

      <input
        autoComplete="disable-autofill"
        // style={{paddingLeft: rupeeSymbol ? '50px !important' : ''}}
        disabled={disabled}
        ref={ref}
        name={name}
        type={type}
        onFocus={onFocus}
        onBlur={onBlur}
        id={name}
        className={"form-control" + ' ' + className}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        min={type === "date" ? (datemin ? new Date(datemin)?.toISOString()?.split("T")[0] : '') : min}
        max={max}
        onClick={onClick}
        maxLength={maxLength}
        minLength={minLength}
        onInput={onInput}
        onKeyDown={onKeyDown}
        accept={accept}
      />
      {postAddon && (
        <>
          <div className="__postNums">{postText}</div>
        </>
      )}
      {rupeeSymbol && <div className="__currencyDiv">₹</div>}

      {isClearOption && value != "All" && (
        <span className="clear-icon" onClick={isClearHandleChange}>
          <RxCross2 size={20} color="black" />
        </span>
      )}

      {settingIcon && (
        <span className="setting-icon" onClick={isSettingHnadle}>
          <IoSettingsOutline size={24} />
        </span>
      )}
      {postButton && (
  <span 
    className="post-action-btn" 
    onClick={onPostButtonClick}
  >
    {postButtonLabel}
  </span>
)}

      {label && (
        <label htmlFor="floatingInput" className={settingIcon ? "settingLabel" : ""}>
          <span>{label} {labelRedStar && <span className="requiredLable"> * </span>}</span>
        </label>
      )}
      
      {errorShow && <>
        {error && (
          <span className={"input_drop_error" + error_class}>
            {error}
          </span>
        )}
      </>}

    </div>
  );
};

export default CommonInput;